import { render, staticRenderFns } from "./Scratch_Input.vue?vue&type=template&id=494fe66c&scoped=true"
import script from "./Scratch_Input.vue?vue&type=script&lang=js"
export * from "./Scratch_Input.vue?vue&type=script&lang=js"
import style0 from "./Scratch_Input.vue?vue&type=style&index=0&id=494fe66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494fe66c",
  null
  
)

export default component.exports